import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import {
  changeContractualPlanning,
  selectPartner360Data,
} from 'legacy/lut/features/partner360/configuration'
import { updateSectionSettings } from 'legacy/lut/features/partner360/sectionSettings'
import { IClientSectionSettings } from 'legacy/lut/features/partner360/sectionSettings/models/iSectionSettingsState'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { getNAField } from '../../../helpers/getNAField'
import { SETTINGS_CONTRACTUAL_SUFFIX } from '../../../models'

interface IUseCorePrintActionsParameters {
  programType: ProgramTypes
}

export const useContractualPlanning = ({ programType }: IUseCorePrintActionsParameters) => {
  const dispatch = useAppDispatch()
  const { planning } = useSelector(selectPartner360Data)

  const setContractualPlanningActive = useCallback(async () => {
    const newValue = 1
    const field = getNAField(programType, SETTINGS_CONTRACTUAL_SUFFIX)
    const settingForUpdate = { [field]: newValue } as Partial<IClientSectionSettings>

    await dispatch(
      updateSectionSettings({
        sectionSettings: settingForUpdate,
        flag: field,
        state: newValue,
        controlName: 'Planning',
      })
    ).unwrap()

    dispatch(changeContractualPlanning(!!newValue))
  }, [dispatch, programType])

  return {
    isContractualPlanningActive: planning.isCorePrintContractualPlanningActive,
    setContractualPlanningActive,
  }
}
